(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["py-hero-slider"] && !Shopify.designMode) return;
  try {
    
  /* Perfect Yarns hero slider: dots, arrows and autoplay. No libraries. */
  if (!customElements.get('py-slider')) {
    customElements.define(
      'py-slider',
      class PySlider extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          this.track = this.querySelector('[data-slides]');
          this.dotsBox = this.querySelector('[data-dots]');
          if (!this.track || !this.dotsBox) return;
          this.slides = Array.from(this.track.children);
          if (this.slides.length < 2) return;
          this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.dotsBox.innerHTML = '';
          this.dots = this.slides.map((slide, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'py-dot';
            dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            dot.addEventListener('click', () => {
              this.go(i);
              this.restart();
            });
            this.dotsBox.appendChild(dot);
            return dot;
          });

          this.querySelectorAll('[data-dir]').forEach((arrow) => {
            arrow.addEventListener('click', () => {
              this.go(this.current() + Number(arrow.dataset.dir));
              this.restart();
            });
          });

          this.track.addEventListener('scroll', () => window.requestAnimationFrame(() => this.mark()), { passive: true });
          this.addEventListener('pointerenter', () => this.stop());
          this.addEventListener('pointerleave', () => this.restart());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('shopify:block:select', (event) => {
            const index = this.slides.indexOf(event.target);
            if (index > -1) {
              this.stop();
              this.go(index, true);
            }
          });

          this.mark();
          this.restart();
        }

        disconnectedCallback() {
          this.stop();
        }

        current() {
          return Math.round(this.track.scrollLeft / this.track.clientWidth);
        }

        go(index, instant) {
          const count = this.slides.length;
          const target = ((index % count) + count) % count;
          this.track.scrollTo({
            left: target * this.track.clientWidth,
            behavior: this.reduce || instant ? 'auto' : 'smooth',
          });
        }

        mark() {
          const active = this.current();
          this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === active ? 'true' : 'false'));
        }

        stop() {
          clearInterval(this.timer);
        }

        restart() {
          this.stop();
          if (this.reduce || this.dataset.autoplay !== 'true') return;
          this.timer = setInterval(() => this.go(this.current() + 1), Number(this.dataset.speed) || 6000);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
